import { Tab } from "components/TabHeader";

export function isIncludedTab(tab: Tab, tabs?: Tab[]) {
  let isIncluded = false;
  if (!tabs) {
    return isIncluded;
  }

  try {
    for (let obj of tabs) {
      if (obj.text === tab.text) {
        isIncluded = true;
        break;
      }
    }
    return isIncluded;
  } catch {
    return false;
  }
}
